"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
* @class ValueItem
* @desc A text value that can appear next to an icon or a control of some kind
*
* @param {string} [className]
*     Class name(s) to add to the top-level container/div
* @param {string} [data-id=value-item]
*     The data-id of the component
* @param {string} [icon]
*     The icon or control to show left of the text value*
* @param {boolean} [inline=false]
*     When true, the value item displays inline
*/
var ValueItem = function ValueItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataId = _ref["data-id"],
      icon = _ref.icon,
      inline = _ref.inline;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("value-item", className, inline ? "value-item__inline" : null),
    "data-id": dataId
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "value-item__icon"
  }, icon), children && /*#__PURE__*/_react.default.createElement("span", {
    className: "value-item__value"
  }, children));
};

ValueItem.propTypes = {
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  icon: _propTypes.default.node,
  inline: _propTypes.default.bool
};
ValueItem.defaultProps = {
  "data-id": "value-item",
  inline: false
};
var _default = ValueItem;
exports.default = _default;
module.exports = exports["default"];